import * as yup from 'yup';

export const VAT_COUNTRY_OPTIONS = [
  { label: 'Italia', value: 'IT', regex: /^((IT)?[0-9]{11})?$/ },
];

const IT_VAT_REGEX = VAT_COUNTRY_OPTIONS[0].regex;
const STATE_REGEX = /^([A-Z]{2})?$/;

const firstNonEmptyString = (...values) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return '';
};

const normalizeProvince = (value = '') => {
  const compact = String(value).replace(/[^A-Za-z]/g, '').toUpperCase();
  if (compact.length === 2) return compact;
  return '';
};

export const getBillingInitialValues = (salon = {}) => {
  const indirizzo = salon.indirizzo && typeof salon.indirizzo === 'object' ? salon.indirizzo : {};
  const indirizzoString = typeof salon.indirizzo === 'string' ? salon.indirizzo : '';

  return {
    pec: firstNonEmptyString(salon.pec),
    codiceVat: 'eu_vat',
    pIva: firstNonEmptyString(salon['P.IVA'], salon.piva, salon.pIva, salon.partitaIva),
    nomeSalone: firstNonEmptyString(salon.nome_salone, salon.name),
    phone: firstNonEmptyString(salon.tel, salon.phoneNumber, salon.phone),
    city: firstNonEmptyString(
      salon.citta,
      salon.comune,
      salon.city,
      salon.localita,
      indirizzo.citta,
      indirizzo.comune,
      indirizzo.city,
    ),
    country: 'IT',
    line1: firstNonEmptyString(salon.via, indirizzo.via, indirizzo.line1, indirizzo.street, indirizzoString),
    line2: firstNonEmptyString(salon.civico, salon.n_civico, indirizzo.line2, indirizzo.numero, indirizzo.civico),
    postal_code: firstNonEmptyString(salon.cap, salon.CAP, indirizzo.cap, indirizzo.postal_code),
    state: normalizeProvince(
      firstNonEmptyString(
        salon.sigla_provincia,
        salon.prov,
        salon.provincia,
        indirizzo.provincia,
        indirizzo.state,
      ),
    ),
  };
};

export const getBillingValidationSchema = () => ({
  pec: yup.string('Inserisci una PEC valida').required('Questo campo è obbligatorio'),
  phone: yup
    .string('Inserisci numero di cellulare')
    .min(9, 'Formato non valido')
    .required('Questo campo è obbligatorio'),
  pIva: yup
    .string('Inserisci la partita IVA')
    .matches(IT_VAT_REGEX, 'Partita IVA non valida'),
  city: yup.string('Inserisci città').required('Questo campo è obbligatorio'),
  country: yup.string().required('Questo campo è obbligatorio'),
  line1: yup.string().required('Questo campo è obbligatorio'),
  line2: yup.string().required('Questo campo è obbligatorio'),
  postal_code: yup.string().required('Questo campo è obbligatorio'),
  state: yup
    .string()
    .transform((value) => normalizeProvince(value))
    .matches(STATE_REGEX, "Provincia non valida (utilizza il formato 'RM')")
    .required('Questo campo è obbligatorio'),
});

export const buildStripeCustomerPayload = (values) => ({
  name: values.nomeSalone,
  phone: values.phone,
  email: values.pec,
  address: {
    city: values.city,
    country: values.country || 'IT',
    line1: values.line1,
    line2: values.line2,
    postal_code: values.postal_code,
    state: normalizeProvince(values.state),
  },
  tax_id_data: [{
    type: values.codiceVat,
    value: values.pIva.includes('IT') ? values.pIva : `IT${values.pIva}`,
  }],
});
